var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00DF5E;}\n\t.st1{fill:#FFFFFF;stroke:#1FFF65;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1599",
    className: "st1",
    d: "M70.5,161.5c28,14.9,57.2,30.4,79.8,42.5l79.1-42.5c-28.7,42.6-52.5,78-79.1,117.2 C123.7,239.6,94.2,196.4,70.5,161.5z M73.6,149.7l76.8-41l75.8,40.7l-75.8,41.1L73.6,149.7z M150.3,95.6l-79.8,42L150,21.3 l79.5,116.6L150.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1593",
    className: "st1",
    d: "M150.3,204l79.1-42.5c-28.7,42.6-79.1,117.2-79.1,117.2V204z M150.4,108.7l75.8,40.7 l-75.8,41.1L150.4,108.7z M150.3,95.6L150,21.3l79.5,116.6L150.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1603",
    className: "st1",
    d: "M73.6,149.7l76.8,6.3l75.8-6.6l-75.8,41.1L73.6,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1606",
    className: "st1",
    d: "M150.4,156l75.8-6.6l-75.8,41.1L150.4,156z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc);
export default __webpack_public_path__ + "static/media/ETC.2ba36100f3e0e2de1aa5550fd72ba96b.svg";
export { ForwardRef as ReactComponent };